import React from 'react';
import Select from 'react-select';

import selectTheme from '../FormComponents/selectTheme';
import { selectStyleProps, hideSeparatorLine } from './styles';
import useTheme from '../../theme/useTheme';

const DropdownMenu = ({ options, onSelect }) => {
  const { theme } = useTheme();
  return (
    <>
      <Select
        options={options}
        styles={selectStyleProps(theme)}
        themes={options => selectTheme(options, theme)}
        onChange={option => onSelect(option.value, option.label)}
        components={hideSeparatorLine}
      />
    </>
  );
};

export default DropdownMenu;
